module.exports = __webpack_public_path__ + "static/img/png-file-format.61cd923.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/document/png-file-format.png
// module id = /JWE
// module chunks = 4